// Copyright ©️ 2026 eVolve MEP, LLC

import { Popover, ActionIcon, Switch, Stack } from '@mantine/core';

import { EvolveIcon } from 'assets/icons/EvolveIcon';
import { TextInputDebounced } from 'components/Mantine/TextInputDebounced';

export type WorkOrderFiltersState = {
  searchPhrase: string;
  includeCompleted: boolean;
};

type Props = {
  filters: WorkOrderFiltersState;
  onChange: (filters: WorkOrderFiltersState) => void;
};

export const WorkOrderFabricationFilters = ({ filters, onChange }: Props) => (
  <>
    <TextInputDebounced
      flex={1}
      placeholder="Search..."
      value={filters.searchPhrase}
      onChange={(v) =>
        onChange({
          ...filters,
          searchPhrase: v,
        })
      }
    />
    <Popover>
      <Popover.Target>
        <ActionIcon variant="light" size="input-sm">
          <EvolveIcon icon="Filter" />
        </ActionIcon>
      </Popover.Target>
      <Popover.Dropdown>
        <Stack gap="sm">
          <Switch
            label="Include completed work orders"
            checked={filters.includeCompleted}
            onChange={(e) => onChange({ ...filters, includeCompleted: e.currentTarget.checked })}
          />
        </Stack>
      </Popover.Dropdown>
    </Popover>
  </>
);
